module.exports = __webpack_public_path__ + "img/mimk-wallet.95a4054a.svg";